import React from "react";

import { reactComponentType } from "2g-types";

import useZdrojeTabs from "./useZdrojeTabs";
import { ZdrojeTabsContent } from "./ZdrojeTabsContent";

export function ZdrojeTabs({ contentRenderer }) {
  const params = useZdrojeTabs();
  return <ZdrojeTabsContent contentRenderer={contentRenderer} {...params} />;
}

ZdrojeTabs.propTypes = {
  contentRenderer: reactComponentType
};

export default React.memo(ZdrojeTabs);
